import WrapPageElement from './src/WrapPageElement';

export const wrapPageElement = WrapPageElement;
